import React from "react";
import ProfileContainerComponent from "../components/profile/profileContainer";

export const ProfilePage = () => {
  return (
    <ProfileContainerComponent />
  );
};